import { IHospitalizedHisInformationItemSelectBehavior } from "./IHospitalizedHisInformationItemSelectBehavior";

export interface IHospitalizedHisInformationItemSelectBehaviorSpecifiable {
  hospitalizedHisInformationItemSelectBehavior: IHospitalizedHisInformationItemSelectBehavior;
}

export function instanceOfIHospitalizedHisInformationItemSelectBehaviorSpecifiable(instance: any): instance is IHospitalizedHisInformationItemSelectBehaviorSpecifiable {
  return instance
    && (instance.hospitalizedHisInformationItemSelectBehavior !== undefined);
}
